import { Wording } from '@/types';

export const COOKING_WORDING_BG: Wording = {
  components_header_media_content: 'Видеоклипове за готвене',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Рецепти',
  components_header_text2: 'Блог',
  components_header_members: 'Членове',
  hero_text: 'Гответе със страст, яжте с радост',
  hero_button_text: 'Започнете да готвите още днес',
  components_ressources_section_title: 'РЕСУРСИ',
  components_ressources_subheader_text: 'Всички ресурси, от които се нуждаете, за да учите, готвите и създавате по-добра храна',
  components_ressources_span_text: 'Открийте богата колекция от видео рецепти, подробни ръководства за готвене и експертни съвети за съчетаване на вкусове, представяне на храна и кулинарна креативност.',
  components_ressources_card_1_title: 'Вдъхновение за готвене',
  components_ressources_card_1_text: 'Вдъхновете се от креативни рецепти и кулинарни видеоклипове.',
  components_ressources_card_2_title: 'Знания за готвене',
  components_ressources_card_2_text: 'Научете основни техники за готвене, комбинации от вкусове и основи на съчетаването на храни чрез ясни и практични ръководства.',
  components_ressources_link: 'Гледайте видеоклипове',
  components_notes_and_google_title_1: 'Кулинарно образование',
  components_notes_and_google_title_2: 'Ежедневно готвене',
  components_notes_and_google_title_3: 'Постоянни кулинарни умения',
  components_review_google_text: 'Отзиви в Google',
  media_content_section_title: 'Видеоклипове за готвене',
  media_content_section_subheader_text: 'Разгледайте рецепти и видеоклипове с инструкции стъпка по стъпка за готвене.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Още видеоклипове',
  text2_section_title: 'Блог',
  text2_section_subheader_text: 'Ръководства и статии',
  text2_section_button_more: 'Още статии',
  components_text1_section_title: 'РЕЦЕПТИ',
  components_text1_subheader_text: 'Вкусни рецепти за ежедневно готвене',
  components_text1_span_text: 'Открийте лесни за следване рецепти, предназначени за ежедневни ястия, с ясни стъпки и страхотни резултати.',
  components_text1_card_1_title: 'Започнете деня си правилно',
  components_text1_card_1_text: 'Прости и вкусни рецепти, за да започнете деня си с лекота и вкус.',
  components_text1_card_3_title: 'Идеи за вкусен обяд',
  components_text1_card_3_text: 'Вкусни рецепти за обяд, които са лесни за приготвяне и пълни с вкус.',
  components_text1_card_2_title: 'Утешителни рецепти за вечеря',
  components_text1_card_2_text: 'Топли, засищащи рецепти за вечеря, идеални за спокойни вечери у дома.',
  components_text1_link: 'Вижте всички рецепти',
  components_footer_text: 'Научете се да готвите по-добре, създайте по-добра храна: Вашата кухня, вашето пътуване.',
  components_footer_info: 'Информация',
  components_footer_registration_number: 'Регистрационен номер',
  components_footer_legal: 'Правни',
  components_footer_terms: 'Общи условия',
  components_footer_privacy: 'Политика за поверителност',
  button_load_more: 'Зареди още',
  page_media_1_content_hero_text: 'Открийте лесни кулинарни видеоклипове за всеки вкус',
  page_text1_hero_text: 'Рецепти',
  page_text1_section_title: 'Съвети за готвене',
  page_text1_subheader_text: 'Рецепти',
  page_text2_hero_text: 'Нашият блог',
  page_text2_section_title: 'Блог',
  page_text2_subheader_text: 'Ръководства и статии',
  enter_email_title: 'Моля, въведете имейл адреса си, за да продължите',
  enter_email_placeholder_email: 'Имейл',
  enter_email_button_enter: 'Въведете',
  components_login_success_text: 'Входът е успешен!',
  components_card_link_media_content: 'Гледайте сега',
  components_card_link_text1_content: 'Вижте рецептата',
  components_card_link_text2_content: 'Вижте статията',
};